module.exports = __webpack_public_path__ + "img/receive.d0413dde.png";